import Model from "~/models/_Model";
import dayjs from "dayjs";
import User from "../User";
import Student from "./Student";

export default class Note extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/courseplanner";
  }

  // Set the resource route of the model
  resource() {
    return "notes";
  }

  relations() {
    return {
      author: User,
      student: Student,
    };
  }

  // Define the primary key of the model
  primaryKey() {
    return "record_id";
  }

  // Computed Attributes
  get display_entry_date_time() {
    return dayjs(this.ENTRY_DATE_TIME).format("MM/DD/YYYY h:mm:ss A");
  }

  get display_author() {
    return this.author ? this.author.display_name : this.ENTRY_UID;
  }
}
